import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import { AddIcon, HeartIcon, SendIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, FlexGap } from '@treams/treams-ui';

export default function UserFeedbackButtons(props: { user?: graphql.User }) {
	const { t } = useTranslation();
	const hasCompliments = useFeature(graphql.FeatureName.Compliments);
	const canRequestFeedback = useFeature(graphql.FeatureName.FeedbackAdhoc);
	const canGiveFeedback = useFeature(graphql.FeatureName.FeedbackSpontaneous);

	if (!props.user) {
		return null;
	}

	return (
		<FlexGap gap={12} flexWrap="wrap">
			{props.user.viewerCanRequestFeedback && canRequestFeedback && (
				<Button
					icon={<AddIcon />}
					title={t('user.feedback.index.new', { name: props.user.firstName })}
					link={`/users/${props.user.id}/feedback/request-from-moment`}
				/>
			)}

			{canGiveFeedback && (
				<Button
					type="secondary"
					icon={<SendIcon />}
					title={t('user.feedback.index.spontaneous', { name: props.user.firstName })}
					link={`/users/${props.user.id}/feedback/send`}
				/>
			)}

			{hasCompliments && (
				<Button
					type="secondary"
					icon={<HeartIcon />}
					title={t('user.compliments.index.new', { name: props.user.firstName })}
					link={`/users/${props.user.id}/feedback/compliments/new`}
				/>
			)}
		</FlexGap>
	);
}
